import { render, staticRenderFns } from "./TabContent3.vue?vue&type=template&id=2ea8ade2"
import script from "./TabContent3.vue?vue&type=script&lang=js"
export * from "./TabContent3.vue?vue&type=script&lang=js"
import style0 from "./TabContent3.vue?vue&type=style&index=0&id=2ea8ade2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports